<rcl-modal
	id="terms-of-use-rcl-modal"
	[show]="showTermsOfUseModal"
	[mobileFullScreen]="false"
	[attr.aria-hidden]="!showTermsOfUseModal"
	(onClose)="closeModal()"
>
	<rcl-modal-content id="terms-of-use-rcl-modal__content" [attr.tabindex]="0" tabindex="0">
		<rcl-modal-title id="terms-of-use-rcl-modal__content__title">
			{{ bundle && bundle['terms.of.service.modal.header'] }}
		</rcl-modal-title>
		<span id="terms-of-use-rcl-modal__content__message" [innerHTML]="contentMessage"></span>
	</rcl-modal-content>

	<rcl-modal-actions id="terms-of-use-rcl-modal__actions">
		<button id="terms-of-use-rcl-modal__actions__close" (click)="closeModal()" class="rcl-button-secondary">
			{{ bundle && bundle['button.close'] }}
		</button>
	</rcl-modal-actions>
</rcl-modal>
